import { render, staticRenderFns } from "./CreateScript.vue?vue&type=template&id=c894bdb4&scoped=true"
import script from "./CreateScript.vue?vue&type=script&lang=js"
export * from "./CreateScript.vue?vue&type=script&lang=js"
import style0 from "./CreateScript.vue?vue&type=style&index=0&id=c894bdb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c894bdb4",
  null
  
)

export default component.exports